import { useEffect } from "react";
/**
 *
 * @param {
 * } ref the target element
 * @param {*} callback the function to be called when clicking outside
 * @param {*} excludeElements a list of elements to be excluded from the callback function. these are references and must be received on the current form. ie: ulRef.current
 */
function useClickOutside(ref, callback, opened, excludeElements = []) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        opened &&
        !ref?.current?.contains(event.target) &&
        excludeElements.every((element) => !element.contains(event.target))
      ) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback, excludeElements]);
}

export default useClickOutside;
